import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listConversations } from '../api/conversations';
import { getApiClient } from '../api/factory';
import { isDesktop, setUnreadBadge } from '../lib/desktop-bridge';

// ANX-059 — публикует количество открытых диалогов в tray-badge.
// setUnreadBadge no-op в browser, так что хук безопасно монтировать всегда.
//
// ANX-059-followup: на desktop tray-badge пишет Rust-поллер
// (см. desktop/src/runtime.rs::start_poller). Хук остался для фолбэка
// и для PWA на iOS/Android, где webview не приостанавливается.

const POLL_INTERVAL_MS = 10_000;

export function useUnreadBadge(): void {
  const desktop = isDesktop();
  const { data } = useQuery({
    queryKey: ['conversations', 'open'],
    queryFn: () => listConversations(getApiClient(), { status: 'open' }),
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
    enabled: !desktop,
  });

  useEffect(() => {
    if (desktop || !data) return;
    void setUnreadBadge(data.conversations.length);
  }, [desktop, data]);
}
